import sharedStyles from 'styles/css/SharedStyles.module.scss';
import ShortHeaderWithBackBtnNameOfGod from 'components/root/partials/header/ShortHeaderWithBackBtnNameOfGod';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataSurguryConsultationPage } from "reduxx/actions/pages/surguryConsultation";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import apiRequest from 'utils/apiRequest';
import { SURGURY_CONSULTATION } from 'apis'; 

const SurgeryConsultation = () => {

    const dispatch = useDispatch();

    const { inputFullname, inputMobile, inputEmail, inputComment } = useSelector(state => state.surguryConsultation);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        
        if(name === 'inputComment' && value.length > 700)
            return;

        if(name === 'inputMobile')
            dispatch(handleChangeDataSurguryConsultationPage(name, changeNumberPersianAndArabic(value)));
        else 
            dispatch(handleChangeDataSurguryConsultationPage(name, value));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

    const handleSubmitForm = (event) => {
        event.preventDefault();

        if(inputFullname.trim().length < 3) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام و نام خانوادگی خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else if(inputMobile.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputMobile.trim().length !== 11)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت باید 11 رقم باشد  ', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputComment.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'متن نظر را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else {
            if(! isBackdropLoading) {
                apiRequest({
                    dispatch,
                    endpoint: SURGURY_CONSULTATION,
                    method: 'post',
                    data: { mobile: inputMobile, fullname: inputFullname, email: inputEmail, comment: inputComment },
                    token: null,
                    successMessage: 'درخواست شما با موفقیت ثبت شد',
                    onSuccess: (res) => {
                        dispatch(handleChangeDataSurguryConsultationPage('inputMobile', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputFullname', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputEmail', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputComment', ''));
                        // navigate(`verify`);
                    },
                });
            }

        }
    };

    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtnNameOfGod />
                

                <p className={[formStyles['text-center'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    دکتر بیست با کمال افتخار، خدمات جامع پزشکی و مشاوره تخصصی را به توریست‌های عزیز ایرانی (در شیراز  و سایر استان‌ها) و گردشگران سلامت از سایر کشورها ارائه می‌دهد.
                </p>

                <p className={ruleStyles['text-justify']}>
                    این خدمات شامل تمامی رشته‌های پزشکی و جراحی تخصصی و فوق‌تخصصی در بیمارستان‌ها و مراکز درمانی معتبر ایران (دارای شاخص IPD) است.
                </p>

                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۱- پیوند اعضا(Organ Transplantation)
                </p>
                <ul>
                    <li>پیوند کبد</li>
                    <li>پیوند قرنیه</li>
                    <li>پیوند کلیه</li>
                    <li>پیوند قلب و ریه</li>
                    <li>پیوند مغز استخوان</li>
                    <li>پیوند پانکراس (لوزالمعده)</li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۲- چشم‌پزشکی (Ophthalmology)
                </p>
                <ul>
                    <li>لیزیک (LASIK) و PRK</li>
                    <li>پیوند قرنیه و کراتوپلاستی</li>
                    <li>جراحی آب مروارید  (Cataract)</li>
                    <li>جراحی آب سیاه  (Glaucoma)</li>
                    <li>اپتومتری و تصحیح عیوب انکساری چشم</li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۳- دندان‌پزشکی عمومی و تخصصی 
                    <br />
                    (General & Specialized Dentistry)
                </p>
                ارائه‌ی کلیه‌ی خدمات دندان‌پزشکی با بهره‌گیری از متخصصان مجرب در رشته‌های مختلف، شامل:
                <ul>
                    <li>
                        خدمات عمومی:
                        <ul>
                            <li>جرم‌گیری و بروساژ</li>
                            <li>پر کردن و ترمیم دندان</li>
                            <li>درمان ریشه  (Root Canal Therapy)</li>
                            <li>کشیدن و جراحی دندان‌های نهفته</li>
                        </ul>
                    </li>
                    <li>
                        خدمات تخصصی:
                        <ul>
                            <li>ایمپلنتولوژی (کاشت دندان): کاشت ایمپلنت و بازسازی لبخند</li>
                            <li>ارتودنسی: صاف و منظم‌سازی دندان‌ها با براکت یا الاینر شفاف</li>
                            <li>درمان ریشه  (Root Canal Therapy)</li>
                            <li>پروتز و زیبایی: پروتز و زیبایی:</li>
                        </ul>
                    </li>
                    <li>
                        طراحی لبخند، لمینت، روکش، بلیچینگ
                        <ul>
                            <li>دندان‌پزشکی کودکان: درمان دندان‌های شیری و مراقبت دهان کودکان</li>
                            <li>درمان لثه:  (Periodontics)جراحی و درمان بیماری‌های لثه و ایمپلنت</li>
                            <li>جراحی فک و صورت: جراحی دندان‌های نهفته، اصلاح فک و بازسازی استخوان</li>
                            <li>رادیولوژی و پاتولوژی دهان: تشخیص ضایعات دهانی با تصویر‌برداری تخصصی و بررسی بافت‌شناسی</li>
                        </ul>
                    </li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۴- پوست، مو و زیبایی (Cosmetic & Dermatology)
                </p>
                <ul>
                    <li>کاشت مو، ابرو و مژه</li>
                    <li>لیزر و ریمو تاتو، خال و زگیل</li>
                    <li>جوان‌سازی پوست، تزریق بوتاکس و فیلر</li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۵- قلب و عروق  (Cardiology)
                </p>
                <ul>
                    <li>اکوکاردیوگرافی</li>
                    <li>بالون و استنت‌گذاری  (Angioplasty)</li>
                    <li>رفع تنگی عروق کرونر با روش‌های های‌تک</li>
                    <li>جراحی قلب باز  (CABG)</li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۶- گوش، حلق و بینی  (ENT)
                </p>
                <ul>
                    <li>جراحی زیبایی بینی</li>
                    <li>اصلاح انحراف تیغه بینی</li>
                    <li>برداشتن پولیپ بینی</li>
                    <li>جراحی لوزه  (Tonsillectomy)</li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۷- ارتوپدی  (Orthopedics)
                </p>
                <ul>
                    <li>تعویض مفصل زانو و لگن</li>
                    <li>آرتروسکوپی</li>
                    <li>جراحی دیسک کمر و گردن</li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۸- جراحی مغز و اعصاب  (Neurosurgery)
                </p>
                <ul>
                    <li>جراحی تنگی کانال نخاعی</li>
                    <li>جراحی تومورهای مغزی و نخاعی</li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۹- اورولوژی  (Urology)
                </p>
                <ul>
                    <li>درمان سنگ کلیه و مثانه</li>
                    <li>درمان بزرگی پروستات  (BPH)</li>
                    <li>جراحی تومورهای دستگاه ادراری</li>
                </ul>


                <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    ۱۰- بیماری‌های داخلی  (Internal Medicine)
                </p>
                <ul>
                    <li>قلب، ریه، گوارش، غدد، مغز و اعصاب، و روماتولوژی</li>
                </ul>






                <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary'], sharedStyles['mt-[64px]']].join(' ')}>
                    فرم درخواست مشاوره اعمال جراحی
                </div>

                <input type="text" name="inputFullname" value={inputFullname} onChange={handleChangeInputs} className={[formStyles.input, sharedStyles['mt-[16px]']].join(' ')} placeholder="نام و نام خانوادگی" />
                <input type="email" name="inputEmail" value={inputEmail} onChange={handleChangeInputs} className={formStyles.input} placeholder="ایمیل (اختیاری)" />
                <input type="tel" name="inputMobile" value={inputMobile} onChange={handleChangeInputs} className={formStyles.input} placeholder="شماره موبایل" style={{direction: 'rtl'}} />
                <textarea rows={5} name="inputComment" value={inputComment} onChange={handleChangeInputs} className={formStyles.input} placeholder="شرح مختصری از درخواست خود برای پزشک بنویسید" style={{marginBottom: '0'}} />
                <span>{toPersianDigits(inputComment.length)}/{toPersianDigits(700)}</span>
                <button onClick={handleSubmitForm} className={[formStyles.button, sharedStyles['!mt-[24px]']].join(' ')}>ارسال</button>


            </div>
                
        </div>

    );
}

export default SurgeryConsultation;